import storage from "./index";

const menuKey = `menu`;
const menu = {
    set: {
        storage: (newStorage: object): boolean => storage.set.key(menuKey, newStorage),
        key: function(key: string, value?: any): boolean {
            if (`${key}`.length === 0) {
                return false;
            }

            const storageAgers = menu.get() || {};
            if (
                typeof storageAgers === `object`
                && storageAgers !== null
            ) {
                storageAgers[key] = value;

                return this.storage(storageAgers);
            }

            return false;
        },
        keys: function(object: object): void {
            const storageAgers = menu.get() || {};
            if (
                typeof storageAgers !== `object`
                || storageAgers === null
            ) {
                return;
            }

            this.storage(
                {
                    ...storageAgers,
                    ...object
                }
            );
        },
    },
    remove: {
        key : (key: string): void => {
            if (`${key}`.length === 0) {
                return;
            }

            const storageAgers = menu.get();
            if (
                typeof storageAgers === `object`
                && storageAgers !== null
                && storageAgers.hasOwnProperty(key)
            ) {
                storageAgers[key] = undefined;
                delete storageAgers[key];
                menu.set.storage(storageAgers);
            }
        },
        keys: (...keys: string[]): void => {
            const storageAgers = menu.get();
            if (
                typeof storageAgers !== `object`
                || storageAgers === null
            ) {
                return;
            }

            keys.forEach(
                key => {
                    if (storageAgers.hasOwnProperty(key)) {
                        storageAgers[key] = undefined;
                        delete storageAgers[key];
                    }
                }
            );

            menu.set.storage(storageAgers);
        }
    },
    clear : (): void => storage.remove.key(menuKey),
    get: (key?: string) => {
        const storageAgers = storage.get(menuKey);
        if (!key) {
            return storageAgers;
        }

        return typeof storageAgers === `object` && storageAgers !== null && storageAgers.hasOwnProperty(key)
            ? storageAgers[key]
            : undefined;
    },

    isCollapsed: (): boolean => [true, `true`].includes(menu.get(`collapsed`)),
    setCollapsed: (state: boolean): boolean => menu.set.key(`collapsed`, state),
};

export default menu;